/** Source failures are distinct from Kiipu session authentication. Never display raw upstream errors. */
export function captureFailureNotice(code?: string | null, platform?: string) {
  const source = platform === 'wechat' ? '微信公众号' : platform === 'zhihu' ? '知乎' : '来源站点';
  const reasons: Record<string, string> = {
    verification_required: `${source}要求安全验证，云端无法取得正文。`,
    authentication_required: `${source}要求登录后访问，云端无法取得正文。`,
    access_restricted: `${source}拒绝了云端访问（HTTP 403），未返回可保存的正文。`,
    source_unavailable: `${source}返回内容不存在或已删除（HTTP 404/410）。`,
    content_unavailable: '未找到链接对应的正文，页面可能需要在浏览器中加载或展开。',
    platform_url_paused: '此来源的云端解析暂时暂停。',
  };
  const reason = code ? reasons[code] : undefined;
  if (!reason) return null;
  return {
    reason,
    guidance:
      '在 Chrome 中打开原文，按页面提示完成登录或验证，展开正文并等待图片加载，再点击 Kiipu 扩展本地保存；已保存过可点“重新读取当前页面”。本地保存不调用云端解析。',
  };
}
